import { Vue, Component, Mixins } from "vue-property-decorator";
import CollectionControl from '@/components/collection-control';
import XTable from '@/components/x-table';
import XTh from '@/components/x-table/x-th';
import ActionTd from '@/components/x-table/action-td';
import ActionTh from '@/components/x-table/action-th';
import PanelSourcesInfo from '../../components/panel-sources-info';
import { DynPanelAware } from '@/components/dyn-panel';
import CavSourcesInfo from '@/lib/models/cav-source-info';
import { State } from 'vuex-class';
import CavCavite from '@/lib/models/cav-cavite';

@Component
export default class PartSourcesInfos extends Mixins(DynPanelAware) {

  @State(s => s.caviteEdit.editedCavite) data: CavCavite;

  render() {
    return (
      <div class="main-tab-inner">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label is-small">
                Sources d'informations associées
              </label>
              <CollectionControl
                data={this.data.cavSourcesInfos}
                clazz={PanelSourcesInfo}
                scopedSlots={{
                  body: ({ data, onEdit, onDelete }) => (
                    <XTable data={data}
                      class="is-full-width is-bordered is-small"
                      scopedSlots={{
                        header: () => (
                          <tr>
                            <XTh prop="numCavite">Source d'information</XTh>
                            <XTh prop="nomCavite">Lieu d'archivage</XTh>
                            <ActionTh/>
                          </tr>
                        ),
                        row: ({d}: {d: CavSourcesInfo}) => (
                          <tr>
                            <td>{d.sourceInformation}</td>
                            <td>{d.lieuArchivage}</td>
                            <ActionTd
                              onEdit={() => onEdit(d)}
                              onDelete={() => onDelete(d)}
                            />
                          </tr>
                        )
                      }}>
                    </XTable>
                  )
                }}>
              </CollectionControl>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-337fbc6e/sources-infos.tsx" });